<template>
  <section>
    <time-line :showEventFilter="true" :target="identity" :fields="fields"></time-line>
    <el-card :header="$t('deviceInfoCardHeader')" data-qa="Content-DeviceInfo-Card-Users">
      <el-row :gutter="20">
        <el-col :span="4"><b>{{ $t('deviceInfoLabelOwnerText') }}</b></el-col>
        <el-col :span="8">{{ owner }}</el-col>
        <el-col :span="4"><b>{{ $t('deviceInfoLabelGuestsText') }}</b></el-col>
        <el-col :span="8">
          <div :key="index" v-for="(guest, index) in guests">{{ guest }}</div>
        </el-col>
      </el-row>
    </el-card>
  </section>
</template>

<script>
  import main from './DeviceInfo.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './DeviceInfo.scss'
</style>



// WEBPACK FOOTER //
// DeviceInfo.vue?7ebddfd9